import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/hse.css';

function Home() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50); // Delay before animation starts
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Section 1: Mission & Vision */}
            <div className="container-fluid about-bg6 d-flex align-items-end mb-5" style={{ padding: 0, minHeight: '75vh' , top: -122 }}>
                <div className="container-fluid align-items-center justify-content-center about-content">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="d-flex flex-column flex-md-row align-items-start ms-5">
                                <div className="me-md-5">
                                    <h1 className="about-title">HSE Services</h1>
                                    <h2 className="about-subtitle">Petrochoice Integrated Services</h2>
                                    <div className="about-underline" ref={underlineRef}></div>
                                </div>
                                {/* <div>
                                    <p className="about-desc ms-5 align-items-center" style={{ fontSize: 19 }}>
                                        At Petrochoice, we provide a comprehensive team of specialized drilling personnel and performance specialists, including rig crew members, who are crucial to optimizing drilling operations, minimizing lost time, and reducing costs. Our diverse team comprises experts in various drilling aspects, ensuring that we offer comprehensive support and expertise throughout the drilling process.
                                    </p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 2: Info */}

            <div className="container d-flex align-items-center justify-content-start mb-5 hse-section" style={{ padding: 0, minHeight: '100vh' }}>
                <div className="row w-100">
                    <div className="col-lg-5 col-md-12">
                        <h2 className="hse-title">HSE Services</h2>
                        <p className="hse-text" style={{ fontSize: '1.3rem' }}>
                            At the core of our operational ethos lies an unwavering commitment to safety and environmental stewardship. Our Health, Safety, and Environment (HSE) services stand as a robust shield against risk, assuring both compliance with stringent industry regulations and the implementation of best practices. Rooted in this commitment are a suite of HSE services that encompass comprehensive audits, meticulous risk assessments, bespoke training programs, and unwavering support in crafting and implementing safety management services. Our overarching goal is to sculpt a work environment where safety is paramount, where every team member returns home unharmed, and where environmental preservation is a guiding principle. This commitment reverberates through every phase of the project lifecycle, ensuring not only the safeguarding of lives but also the preservation of the ecosystems that surround and sustain us.
                        </p>
                    </div>
                    <div className='col-lg-1'></div>
                    <div className="col-lg-6 col-md-12">
                        <div className="hse-image">
                            <img src="/assets/maaan.jpg" alt="HSE Operations" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
